import React, { Dispatch, SetStateAction } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Form } from "../interfaces";
import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

interface Props {
  label: string;
  fieldName: string;
  currentValue: boolean | undefined;
  form: Form;
  setForm: Dispatch<SetStateAction<any>>;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  labelText: {
    "& .MuiTypography-body1": {
      color: theme.palette.primary.main,
    },
  },
}));

export default function IncludeCheckbox({
  label,
  fieldName,
  currentValue,
  form,
  setForm,
  disabled,
}: Props) {
  const [check, setCheck] = React.useState<boolean>(
    !currentValue ? false : currentValue,
  );

  const classes = useStyles();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheck(event.target.checked);
    setForm({ ...form, [fieldName]: !check });
  };
  return (
    <FormControlLabel
      className={classes.labelText}
      control={
        <Checkbox
          id={fieldName}
          disabled={disabled}
          color="primary"
          disableFocusRipple
          checked={check}
          onChange={handleChange}
          name={label}
        />
      }
      label={label}
    />
  );
}
